import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef as MatDialogRef, MAT_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatTableDataSource as MatTableDataSource } from '@angular/material/table';
import { SelectionModel } from '@angular/cdk/collections';
import { ToastrService } from 'ngx-toastr';
import { RequesterService } from '../../services/requester.service';
import { MsalService } from '@azure/msal-angular';

@Component({
  selector: 'app-manual-outliers-removal',
  templateUrl: './manual-outliers-removal.component.html',
  styleUrls: ['./manual-outliers-removal.component.scss'],
  standalone: false
})
export class ManualOutliersRemovalComponent implements OnInit {
  displayedColumns: string[] = ['select', 'convertedTS', 'value'];
  dataSource = new MatTableDataSource<any>([]);
  selection = new SelectionModel<any>(true, []);
  selectedParam: any;
  userDtls: any = {};

  constructor(
    public dialogRef: MatDialogRef<ManualOutliersRemovalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private authService: MsalService,
    private toastr: ToastrService,
    private requester: RequesterService,
  ) {
    this.dataSource.data = this.data.pointsArr;
    this.selectedParam = this.data.selParam;
  }

  ngOnInit() {
    // this.userDtls = this.adalService.userInfo;
    const account = this.authService.instance.getActiveAccount();
    this.userDtls = account ? account : {};
  }

  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows;
  }

  masterToggle() {
    this.isAllSelected() ?
      this.selection.clear() :
      this.dataSource.data.forEach(row => this.selection.select(row));
  }

  checkboxLabel(row?: any): string {
    if (!row) {
      return `${this.isAllSelected() ? 'select' : 'deselect'} all`;
    }
    return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row ${row.position + 1}`;
  }

  submit() {
    this.requester.removeManualOutliers(this.selection.selected, this.selectedParam, this.userDtls).subscribe(
      res => {
        if (res && res.status === 'Success') {
          this.toastr.success('Removed selected outliers', 'Success');
        }
        this.dialogRef.close(this.selectedParam);
      }
    );
  }
}
